// react
import React from 'react';

// relative
import BaseloadDeviation from './BaseloadDeviation';

function parseMetaData(value) {
  if (!value) return null;

  if (typeof value === 'object') return value;

  if (typeof value !== 'string') return null;

  const normalizedJson = value
    .replace(/\bNaN\b/g, 'null')
    .replace(/\bInfinity\b/g, 'null')
    .replace(/\b-Infinity\b/g, 'null');

  return JSON.parse(normalizedJson);
}

function renderAlarmSubtype(alarmSubType, metaData, alarm) {
  switch (alarmSubType) {
    case 'BaseloadDeviation':
      return <BaseloadDeviation data={metaData} alarm={alarm} />;
    default:
      return <pre>{JSON.stringify(metaData, null, 2)}</pre>;
  }
}

const ElectricitySystem = ({ alarm }) => {
  const metaData = parseMetaData(alarm?.MetaData ?? alarm?.metaData);
  const subType =
    alarm?.AlarmSubtype ?? alarm?.alarmSubtype ?? 'Unknown Subtype';

  return (
    <React.Fragment>
      {renderAlarmSubtype(subType, metaData, alarm)}
    </React.Fragment>
  );
};

export default ElectricitySystem;
